import NumericField from './NumericField.container';
import { INumericField } from './NumericField.interfaces';

export default NumericField;
export { NumericField, INumericField };
